module.exports = __webpack_public_path__ + "static/media/answer_fail.22aacbd0.mp3";